import { StringUtils } from 'utils/string'
import { IListItems, IItem } from '../list-interface'

export const LIST_WIDGET_NO_ITEMS =
    'Sorry, no articles could be found for this list.'
export const LIST_WIDGET_NOT_ENOUGH_ITEM = 'Items are not enough'

const renderArticlesList = (
    props: IListItems,
    maxItems: number,
    minItems: number,
    listType?: string,
    listName?: string,
    listRender?: string,
    listUrl?: string,
    listPos?: number
): string => {
    const { items } = props

    // Limit the items to display
    const limitedItems = items.slice(0, maxItems)

    if (items.length < minItems) {
        return LIST_WIDGET_NOT_ENOUGH_ITEM
    }

    const renderedItems = limitedItems
        .map((item: IItem, index: number) => {
            const id = item._id || ''
            const title = StringUtils.convertQuotesToEntity(
                item.title || (item.titles && item.titles.main) || ''
            )
            const url = item.get_html_canonical_url || item.origin_url || ''

            const clickEvent = `data-evt="click" data-evt-typ="widget" data-evt-val='{
                "wdgt": {
                    "type": "${listType} ${listRender}",
                    "name": "${listName}",
                    "pos": "${listPos}"
                },
                "refUrl": "${listUrl}",
                "storyPos": "${index}",
                "story": {
                    "id": "${id}",
                    "title": "${title}",
                    "url": "${url}"
                }
            }'`

            // Determine if the given link is internal or external
            // set target=_blank (new tab) for external urls
            const target = StringUtils.getHrefTarget(url)

            return `
                <li data-article-id="${id}">
                    <a href="${url}" ${target} ${clickEvent}>${title}</a>
                </li>`
        })
        .join('')

    return `
        <ul class="list-widget__articles-list">
        ${renderedItems}
        </ul>`
}

export const renderGlobeNewsWireWidget = (
    props: IListItems,
    maxItems: number,
    minItems: number,
    listType?: string,
    listName?: string,
    listRender?: string,
    listUrl?: string,
    listPos?: number
): string => {
    return renderArticlesList(
        props,
        maxItems,
        minItems,
        listType,
        listName,
        listRender,
        listUrl,
        listPos
    )
}
